import StoryblokMedia from "./StoryblokMedia";

export default StoryblokMedia;
